import React from "react";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";

export default function IconButton({ active, label, onClick, children }) {
  return (
    <button
      type="button"
      aria-label={label}
      onClick={onClick}
      className={`absolute top-1/2 right-2 -translate-y-1/2 h-8 w-8 inline-grid place-items-center rounded-full transition ${
        active ? "text-text-primary" : "text-text-muted hover:text-text-primary"
      } focus:outline-none focus:ring-0`}
    >
      {children}
    </button>
  );
}
